import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/garmentCar';


// GETBYID
function getById(state, action) {
  state.getById.data = action.payload.data ? action.payload.data:[];
}

function conexionGetById(state, action) {
  state.getById.connection= action.payload.connection;
}

function errorGetById(state, action) {
  state.getById.error= action.payload.error ? action.payload.error:false;
  state.getById.message= action.payload.message ? action.payload.message:"";
}

function getByIdReset(state, action) {
  state.getById.data=[];
  state.getById.connection= false;
  state.getById.error= false;
  state.getById.message= "";
}

/**
 * Conexión
 */
const garmentCarReducer = createSlice({
  name: 'garmentCar',
  initialState: initState,
  reducers: {
    // GETBYID
    getById,
    conexionGetById,
    errorGetById,
    getByIdReset,
  },
});

export const garmentCarActions = {
  ...garmentCarReducer.actions,
};

export default garmentCarReducer.reducer;
